import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";

const ScrollToTopButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  // Show button after scrolling down
  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  // Scroll smoothly to top
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <motion.button
      onClick={scrollToTop}
      className="btn btn-info btn-scroll-top rounded-circle position-fixed"
      style={{
        bottom: "30px",
        right: "30px",
        width: "45px",
        height: "45px",
        zIndex: 9999,
      }}
      initial={{ opacity: 0, y: 30 }}
      animate={
        isVisible
          ? { opacity: 1, y: 0, pointerEvents: "auto" }
          : { opacity: 0, y: 30, pointerEvents: "none" }
      }
      transition={{ duration: 0.3 }}
    >
      <i className="bi bi-arrow-up"></i>
    </motion.button>
  );
};

export default ScrollToTopButton;
